import {
    OutcomeAllowance,
    SelectedOutcome,
} from '../types';
import { createAllowancesKey } from '../utils';
import { shouldOmitInTarget } from './targetValidator';
import { shouldBeAllowedInPlay } from './inPlayValidator';
import { isMarketSpecifersPairValid } from './specifiersValidator';
import { Country } from '@superbet-group/web.types';

export function isOutcomesCombinationValid(
    outcome1: SelectedOutcome,
    outcome2: SelectedOutcome,
    target: Country,
    allowedOutcomeCombinations?: Record<string, Set<OutcomeAllowance>>,
): boolean {
    if (!allowedOutcomeCombinations) {
        return true;
    }

    if (Object.keys(allowedOutcomeCombinations).length === 0) {
        return true;
    }

    const outcomeCombinationKey = createAllowancesKey(outcome1.outcomeId, outcome2.outcomeId);

    if (!(outcomeCombinationKey in allowedOutcomeCombinations)) {
        return false;
    }

    if (shouldOmitInTarget(outcomeCombinationKey, target, undefined, allowedOutcomeCombinations)) {
        return false;
    }

    if (!shouldBeAllowedInPlay(outcome1, outcome2, undefined, allowedOutcomeCombinations)) {
        return false;
    }

    return isMarketSpecifersPairValid(outcome1, outcome2, undefined, allowedOutcomeCombinations);
}
